import {
	Component
} from '@angular/core';

import { AnalyticsService } from './Analytics.Service';
@Component({
	selector: 'report-tab',
	template: '<ng-content></ng-content>',
	host: {
		layout: 'column',
		'layout-wrap': 'false'
	},
	providers: [
		AnalyticsService
	],
	standalone: false
})
export class ReportTabComponent {
}
